import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UniversityAction } from "../../store/actions";
import { Buttons, Modal } from "..";

const UploadUniImages = ({ text = "Upload Images" }) => {
  const dispatch = useDispatch();
  const fileSelectRef = useRef(null);

  const { isAddLoading } = useSelector((state) => state?.university);
  const [modalVisible, setModalVisible] = useState(false);

  const handleUploadMultiple = (files) => {
    const formData = new FormData();

    Array.from(files).forEach((file) => {
      formData.append("image", file);
    });

    dispatch(UniversityAction.uploadUniImage(formData));
    setModalVisible(false);

    if (fileSelectRef.current) {
      fileSelectRef.current.value = "";
    }
  };

  return (
    <div className="w-[12em]">
      <Buttons.DefaultButton
        size="medium"
        width="full"
        onClick={() => setModalVisible(true)}
        disabled={isAddLoading}
      >
        {text}
      </Buttons.DefaultButton>
      <Modal.DefaultModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
      >
        <div className="w-[35em] flex flex-col gap-4 justify-center items-center">
          <div className="text-main font-bold text-[2em]">Upload Images</div>
          <div className="w-full">
            <div
              className="cursor-pointer border border-dashed border-main rounded-xl p-5 text-center w-full"
              onClick={() => fileSelectRef.current?.click()}
            >
              Select Files
            </div>
            <input
              type="file"
              multiple
              style={{ display: "none" }}
              accept=".jpg,.jpeg,.png"
              ref={fileSelectRef}
              onChange={(event) => {
                if (event.target.files.length > 0) {
                  handleUploadMultiple(event.target.files);
                }
              }}
            />
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default UploadUniImages;
